import { useFetchPicklistsQuery } from '@api'
import { Button, Flexbox, Radio, Spacer, Text } from '@components/common'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import FilterLoading from './FilterLoading'
import { AssetsTableFilterField } from './Filters.types'

interface Props {
  filter: AssetsTableFilterField
}

const PicklistsFilter = ({ filter }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchParamsObject = Object.fromEntries([...searchParams])

  const [picklistValue, setSegmentValue] = useState<string | undefined>(
    searchParams.get(filter.column) ?? undefined
  )

  const inputChangeTimeoutDuration: number = 400

  const {
    data: picklists,
    isLoading: isLoadingPicklists,
    isError: isErrorGettingPicklists,
  } = useFetchPicklistsQuery()

  function onChange(e: any) {
    setSegmentValue(e.target.value)
    setTimeout(() => {
      if (e.target.value === '') {
        searchParams.delete(e.target.name)
        setSearchParams(searchParams)
      } else {
        setSearchParams({
          ...searchParamsObject,
          [e.target.name]: (e.target.value = typeof Number
            ? e.target.value.toString()
            : e.target.value),
          pageNumber: '1',
        })
      }
    }, inputChangeTimeoutDuration)
  }

  function clearSelection() {
    searchParams.delete(filter.column)
    setSearchParams(searchParams)
    setSegmentValue(undefined)
  }

  const filteredPicklist = picklists?.filter(list => list.PKNAME === filter.column)

  if (isErrorGettingPicklists) {
    return <Text intent="danger">Error getting picklists.</Text>
  }

  if (isLoadingPicklists) {
    return <FilterLoading />
  }

  if (filteredPicklist.length === 0) {
    return <Text>No options apply.</Text>
  }

  return (
    <div>
      <Spacer y="mini" />
      <Radio name={filter.column} onChange={onChange} select={picklistValue} legend="">
        {filteredPicklist.map((picklist, index: number) => (
          <Radio.Option
            value={picklist.PKVAL}
            label={picklist.PKVAL}
            autoFocus={index === 0}
            key={picklist.PKVAL}
          />
        ))}
      </Radio>
      <Spacer y="mini" />
      <Flexbox justifyContent="flex-end">
        <Text small>
          <Button
            onClick={() => clearSelection()}
            appearance="text"
            disabled={picklistValue === '' || picklistValue === undefined}
          >
            Clear
          </Button>
        </Text>
      </Flexbox>
    </div>
  )
}
export default PicklistsFilter
